$(function () {

  $('.js-apsara-video').each(function () {
    var $placeholder = $(this);
    var $videoWrapper = $placeholder.parents('.video-player-block');
    if ($placeholder.data('autoplay') === true) {
      playVideo();
    }
    $videoWrapper.find('.btn-play').on('click', playVideo);
    function playVideo() {
      var videoId = $placeholder.data('videoid');
      if (!$videoWrapper.hasClass('has-started')) {
        $videoWrapper.addClass('has-started playing apsara-video');
        $.ajax({
          url: '/api/apsara/GetPlayAuth/?videoId=' + videoId,
          type: "GET",
          success: function (playAuth) {
            var player = new Aliplayer({
              license: {
                domain: "metso.cn",
                key: $placeholder.data('key')
              },
              "id": $placeholder.attr('id'),
              "vid": videoId,
              "playauth": playAuth,
              "qualitySort": "asc",
              "format": "mp4",
              "mediaType": "video",
              "width": "100%",
              "autoSize": "height",
              "autoplay": true,
              "autoplayPolicy": {
                fallbackToMute: true,
                showUnmuteBtn: true,
              },
              "language": "zh-cn", // Set the language to Chinese
              skinLayoutIgnore: [
                'controlBar.subtitle',
                'controlBar.setting'
              ],
              "isLive": false,
              "rePlay": $placeholder.data('loop'),
              "videoHeight": undefined,
              "isVBR": undefined,
              "preload": true,
              "controlBarVisibility": "hover",
              "useH5Prism": true
            }, function (player) {
              player.play();
            });
          },
          error: function () {
            console.log('Error getting playAuth from Apsara.');
            return null;
          }
        });
      }
    }
  });
});